export const salesOrderJoinParams = ['locationCode', 'warehouse', 'contacts']
